<div class="name-search grid">
  <input appCurserSideByLanguaga (keyup)="onKeyUpSearchByName($event)" class="name-input" type="text" placeholder="חפש לפי שם / שם משפחה">
</div>
<div class="count-section grid">
  <div *ngIf="dealersToDisplay" class="count">סוחרים ברשימה {{ dealersToDisplay.length }}</div>
  <div (click)="goToReportPage()" class="display-all-btn button"><i class="icofont-list"></i></div>
</div>
<button *ngIf="sortButtonText" (click)="changeSortMethod()" class="sort-by-button">{{ sortButtonText }}</button>
<app-dealer-list-item *ngFor="let dealer of dealersToDisplay" [dealer]="dealer"></app-dealer-list-item>